import cn from 'classnames';
import type React from 'react';
import { Link } from 'react-router-dom';
import { CoachAvatar } from '@features/coaches/coachCard/coachAvatar/ui.tsx';
import { getInitialM } from '@shared/helpers/index.ts';
import type { Author } from '@shared/types/defaults';
import { TextOverflow } from '@shared/ui/TextOverflow/index.tsx';
import * as st from './AuthorCard.module.scss';

type Props = {
  author: Author;
  saveCurrentPos?: () => void;
  className?: string;
};

export const AuthorCard: React.FC<Props> = ({ author, saveCurrentPos, className }) => {
  const { first_name, middle_name, last_name, coach } = author;
  const name = getInitialM(first_name, middle_name, last_name);
  return (
    <Link
      to={`/coaches/specialists/${author.coach.id}`}
      className={cn(st.author, className)}
      onClick={() => {
        saveCurrentPos && saveCurrentPos();
      }}
    >
      <CoachAvatar photo={author.photo} className={st.img} />
      <div className={st.body}>
        <TextOverflow className={st.name}>{name}</TextOverflow>
        {/*// TODO добавить author.module.verbose_name вместо лфи*/}
        <TextOverflow className={st.specialization}>{coach.module?.verbose_name}</TextOverflow>
      </div>
    </Link>
  );
};
